






import {
	TimeScope
} from "@/classes/TayehApi/Instance";
import {
	Component,
	Prop,
	Vue
} from "vue-property-decorator";

@Component
export default class TimePeriodSelect extends Vue {
	@Prop({default: [TimeScope.DAY, 30]})
	value: [TimeScope, number];

	@Prop({default: 0})
	min: number;

	@Prop({default: 1095})
	max: number;

	private readonly scopeToDay  = {
		'day': 1,
		'week': 7,
		'month': 30,
		'year': 365
	}
	
	public get selectOptions() : {label: string, value: number, object: any}[] {
		return this.options.filter(option => {
			if (!this.min&&!this.max) return true;
			const days = this.calculateDays(option.object);
			return days>=this.min&&days<=this.max
			})
	}

	calculateDays (object: [TimeScope, number]) {
		return this.scopeToDay[object[0]]*object[1]
	}
	

	options: {label: string, value: number, object: any}[]= [{
			label: '۳۰ روز گذشته',
			value: 0,
			object: [TimeScope.DAY, 30]
		},
		{
			label: '۶۰ روز گذشته',
			value: 1,
			object: [TimeScope.DAY, 60]
		},
		{
			label: '۳ ماه گذشته',
			value: 2,
			object: [TimeScope.MONTH, 3]
		},
		{
			label: '۶ ماه گذشته',
			value: 3,
			object: [TimeScope.MONTH, 6]
		},
		{
			label: '۱۲ ماه گذشته',
			value: 4,
			object: [TimeScope.MONTH, 12]
		},
		{
			label: '۲۴ ماه گذشته',
			value: 5,
			object: [TimeScope.MONTH, 24]
		},
		{
			label: '۳ سال گذشته',
			value: 6,
			object: [TimeScope.YEAR, 3]
		},
	];

	option = 0;

	handleChange (e: number) {			
		const object = this.options.find(o => o.value===e).object;			
		this.$emit('change', object);
		this.$emit('update', object);
	}

	getObject(array: any[], value: any) {
		const object = array.find(item => item.object[0] === value[0] && item.object[1] === value[1]);
		return object?object.value:null;
	}

	created() {
		this.option = this.getObject(this.options, this.value)
	}
}
